import React from 'react';
import {
  Skeleton,
} from '@mui/material';
import { BackButton, OutlinedIcons } from '@marageti/z4-lib';
import { ViewProps } from './types';
import SubNavigation from '../sub-navigation';

const TripSecondaryAppbarView = ({
  partner,
  tabs,
  onBackClick,
}: ViewProps) => (
  <SubNavigation
    profile={{
      primary: partner ? partner.name : <Skeleton width={150} />,
    }}
    startAdornment={(
      <BackButton
        data-e2e="ztest-trip-match-back"
        onClick={onBackClick}
        edge="start"
      >
        <OutlinedIcons.OutlinedArrowSmLeftIcon color="primary" />
      </BackButton>
        )}
    tabs={tabs}
  />
);

export default TripSecondaryAppbarView;
